/**
 * Search Modal
 *
 * @See https://tympanus.net/codrops/2017/02/08/inspiration-search-ui-effects/
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2016, Codrops
 * http://www.codrops.com
 */

const SearchModal = {

    mainContainer:  document.querySelector( '[data-js-main-wrap]' ),
    openCtrl: document.querySelector( '[data-js-search-open]' ),
    closeCtrl:  document.querySelector( '[data-js-search-close]' ),
    searchContainer:  document.querySelector( '[data-js-search-popup]' ),
    inputSearch: document.querySelector( '[data-js-search-popup] [data-js-search-input]' ),

    /**
     * Init
     */
    init: function() {

        this.openCtrl.addEventListener( 'click', this.openSearch );
        this.closeCtrl.addEventListener( 'click', this.closeSearch ) ;

        document.addEventListener('keyup', function(ev) {

            // escape key
            if( ev.keyCode == 27 ) {

                SearchModal.closeSearch();

            }
        });
    },

    /**
     * Open
     */
    openSearch: function( event ) {

        event.preventDefault();

        SearchModal.mainContainer.setAttribute( 'data-js-main-wrap', 'moved' );
        SearchModal.searchContainer.setAttribute( 'data-js-search-popup', 'open' );
        setTimeout(function() {

            SearchModal.inputSearch.focus();

        }, 600);
    },

    /**
     * Close
     */
    closeSearch: function() {

        SearchModal.mainContainer.setAttribute( 'data-js-main-wrap', '' );
        SearchModal.searchContainer.setAttribute( 'data-js-search-popup', '' );
        SearchModal.inputSearch.blur();
        SearchModal.inputSearch.value = '';
        console.log( 'close' );
        
    },

 };

( function() {

    SearchModal.init()

} )();


// WEBPACK FOOTER //
// ./assets/frontend/scripts/main/search-modal.js